<template>
  <el-dialog
    title="选择会员信息"
    :visible.sync="dialogVisible"
    width="80%"
    @close="handleClose"
  >
    <el-row>
      <el-col :span="24">
        <el-card header="flex justify-between">
          <el-row :gutter="20">
            <el-col :span="17"></el-col>
            <el-col :span="7">
              <el-input-group>
                <el-input
                  v-model="chooseShopVipUserInfo._currentShopVipUserName"
                  placeholder="输入会员信息名称"
                  size="small"
                />
                <el-button
                  slot="append"
                  type="primary"
                  size="small"
                  @click="queryShopVipUsers"
                >查询</el-button>
              </el-input-group>
            </el-col>
          </el-row>

          <el-table
            :data="chooseShopVipUserInfo.shopVipUsers"
            style="width: 100%; margin-top: 15px"
            border
          >
            <el-table-column prop="vipName" label="会员名称" align="center" />
            <el-table-column prop="vipTel" label="会员电话" align="center" />
            <el-table-column prop="sex" label="性别" align="center">
              <template slot-scope="scope">
                {{ scope.row.sex == 1 ? '男' : '女' }}
              </template>
            </el-table-column>
            <el-table-column prop="startTime" label="入驻时间" align="center" />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="chooseShopVipUser(scope.row)"
                >选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryShopVipUser } from '@/api/goods/chooseShopVipUserApi'

export default {
  name: 'ChooseShopVipUser',
  data() {
    return {
      dialogVisible: false,
      chooseShopVipUserInfo: {
        shopVipUsers: [],
        _currentShopVipUserName: ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._refreshChooseShopVipUserInfo()
      this._loadAllShopVipUserInfo(1, 10, '')
    },
    async _loadAllShopVipUserInfo(page, row, name) {
      try {
        const res = await queryShopVipUser({
          page,
          row,
          shopId: getShopId(),
          name
        })
        this.chooseShopVipUserInfo.shopVipUsers = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    chooseShopVipUser(shopVipUser) {
      if (Object.prototype.hasOwnProperty.call(shopVipUser,'name')) {
        shopVipUser.shopVipUserName = shopVipUser.name
      }
      this.$emit('chooseShopVipUser', shopVipUser)
      this.dialogVisible = false
    },
    queryShopVipUsers() {
      this._loadAllShopVipUserInfo(
        1,
        10,
        this.chooseShopVipUserInfo._currentShopVipUserName
      )
    },
    _refreshChooseShopVipUserInfo() {
      this.chooseShopVipUserInfo._currentShopVipUserName = ''
    },
    handleClose() {
      this._refreshChooseShopVipUserInfo()
    }
  }
}
</script>

<style scoped>
.el-input-group {
  display: flex;
}
</style>